import React from 'react';
import InternalPortal from './internal/components/internal-portal';
import useIsSubsequentRender from './internal/hooks/use-is-subsequent-render';
import useFirePortalEvent from './internal/hooks/use-portal-event';
export default function Portal(props) {
  var _props$zIndex = props.zIndex,
    zIndex = _props$zIndex === void 0 ? 0 : _props$zIndex,
    children = props.children;
  var isSubsequentRender = useIsSubsequentRender();
  useFirePortalEvent(zIndex);
  return isSubsequentRender ? /*#__PURE__*/React.createElement(InternalPortal, {
    zIndex: zIndex
  }, children) : null;
}